import { AndroidOutlined, Mail, NotificationAdd, Notifications } from '@mui/icons-material'
import { AppBar, styled, Toolbar, Typography , Box, InputBase, Badge, Avatar, MenuItem, Menu } from '@mui/material'
import React, { useState } from 'react'



const StyledToolbar = styled(Toolbar)({
     display : "flex",
     justifyContent : "space-between"
})

const Search = styled("div")(({theme}) => ({
backgroundColor : "White",
padding : "0 10px",
borderRadius : theme.shape.borderRadius,
width  : "30%"
}));


const Icons  = styled(Box)(({theme}) => ({
    // backgroundColor : "White"
    display : "none",
    gap : "20px",
    alignItems : "center",
    [theme.breakpoints.up("sm")]:{
        display : "flex"
    }
             
    }));

    const UserBox = styled(Box)(({theme}) => ({

        display : "flex",
        gap : "10px",
        alignItems : "center",
        [theme.breakpoints.up("sm")]:{
            display : "none"
        }
        }));

export const Navbar = () => {

  const [open,setOpen] = useState(false);

  return (
    <AppBar position="sticky">
    <StyledToolbar>
    <Typography variant='h6' sx={{display : {xs : "none" , sm : "block"}}}>ERP VERSE</Typography>
    <AndroidOutlined sx={{display : {xs : "block" , sm : "none"}}}/> 
    <Search><InputBase placeholder='Search here'/></Search>
    <Icons>
    <Badge badgeContent={4} color="error">
  <Mail/>
</Badge>
 <Badge badgeContent={6} color="error">
  <Notifications/>
</Badge>
<Avatar src="https://picsum.photos/200/300" sx = {{width : 30, height : 30}} onClick={e => setOpen(true)}/>
    </Icons>
    <UserBox onClick={e => setOpen(true)}>
    <Avatar src="https://picsum.photos/200/300" sx = {{width : 30, height : 30}}/>
    <Typography variant='span'>User</Typography>
    </UserBox>
    </StyledToolbar>
    <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        // anchorEl={anchorEl}
        open={open}
        onClose = {e=> setOpen(false)}
        // onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem >Profile</MenuItem>
        <MenuItem >My account</MenuItem>
        <MenuItem >Logout</MenuItem>
      </Menu>
   </AppBar>
  )
}
